import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VIcon,{attrs:{"color":"red"},on:{"click":function($event){_vm.dialog = true}}},[_vm._v("mdi-delete")]),_c('SysDialog',{attrs:{"titulo":'Deletar o sub menu: ' + _vm.editar_item.id + ' - ' + _vm.editar_item.descricao + '?',"txtBotao":"Deletar","cor_do_botao":"red"},on:{"click:primary":function($event){return _vm.deletarSubMenu()}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('span')])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }